import { ListItem, styled } from '@mui/material'

export const StyledListItem = styled(ListItem)({
  cursor: 'pointer',
})
